document.addEventListener("DOMContentLoaded", function () {
  let infoButtons = document.querySelectorAll(".info-button");
  const infoCards = document.querySelectorAll('.content_image_with_card .info-card');
  let infoCard ;
  let closeButton;
  let addButton;

  infoButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      updateCardInfo(button);
    });
  });

  let infoButtonsMobile = document.querySelectorAll(".info-button-mobile");
  infoButtonsMobile.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      updateCardInfo(button);
    });
  });


  function updateCardInfo(button) {
    
    
    const infoId = button.getAttribute("data-info");
    if(infoCard && infoCard.id!=infoId){
      clearInfoCards();
    }
    infoCard = document.getElementById(infoId);
    addButton = button.querySelector('.add-icon');
    closeButton = button.querySelector('.close-icon');
    
    if (infoCard.classList.contains('hidden')) {
        clearInfoCards();
        addButton.classList.remove('show');
        addButton.classList.add('hidden');
        closeButton.classList.remove('hidden');
        closeButton.classList.add('show');

        infoCard.classList.remove('hidden');
        infoCard.classList.add('show');
        infoCard.style.top = `${button.offsetTop + 30}px`;
        infoCard.style.left = `${button.offsetLeft}px`;
    } else {
        infoCard.classList.remove('show');
        infoCard.classList.add('hidden');
        if(!closeButton.classList.contains('hidden')){
          closeButton.classList.remove('show');
          closeButton.classList.add('hidden');
        }
        addButton.classList.remove('hidden');
        addButton.classList.add('show');
    }
  }
  function clearInfoCards(){
    if(infoCard){
      infoCard.classList.remove('show');
      infoCard.classList.add('hidden');
      closeButton.classList.remove('show');
      closeButton.classList.add('hidden');
      addButton.classList.remove('hidden');
      addButton.classList.add('show');
    }
  }
});
